var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenImoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2476 28.5C22.875 28.5 28.2476 23.1274 28.2476 16.5C28.2476 9.87258 22.875 4.5 16.2476 4.5C9.62018 4.5 4.2476 9.87258 4.2476 16.5C4.2476 23.1274 9.62018 28.5 16.2476 28.5Z",
    fill: "#028374",
    stroke: "#028374",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 14.6665C13.7425 14.6665 14.4141 13.9949 14.4141 13.1665C14.4141 12.3381 13.7425 11.6665 12.9141 11.6665C12.0857 11.6665 11.4141 12.3381 11.4141 13.1665C11.4141 13.9949 12.0857 14.6665 12.9141 14.6665Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5811 14.6665C20.4095 14.6665 21.0811 13.9949 21.0811 13.1665C21.0811 12.3381 20.4095 11.6665 19.5811 11.6665C18.7527 11.6665 18.0811 12.3381 18.0811 13.1665C18.0811 13.9949 18.7527 14.6665 19.5811 14.6665Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1967 19.6913C20.5232 21.0757 18.4193 21.8332 16.2474 21.8332C14.0755 21.8332 11.9716 21.0757 10.2981 19.6913",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenImoji);
export default __webpack_public_path__ + "static/media/greenImoji.88d7490ecd36f80a024909d7d006b6b0.svg";
export { ForwardRef as ReactComponent };